<ul>
  <li *ngFor="let estado of resumenEstados"
      (click)="clickTipoFirma(capitalizeSingular(estado.tipoEstado))"
      [ngStyle]="{ 'background-color': (capitalizeSingular(estado.tipoEstado)==estadoSeleccionado && colorSeleccion!=='') ? colorSeleccion : ''}"
      class="tooltip"
      [ngClass]="verNuevos ? 'verNuevos':'sinNuevos'">
    <div class="leyenda-color" [class]="estado.tipoEstado"></div>
    <div>{{modificarTitulo(estado.tipoEstado) }}</div>
    <app-indicador-numero *ngIf="verNuevos && estado.nuevos>0" [numero]="estado.nuevos.toString()" [color]="'var(--hs-yellow)'"></app-indicador-numero>
    <span class="flex-right">{{estado.total}}</span>
  </li>
</ul>
